import BorderlessButton from '../common/buttons/BorderlessButton';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';

export const settingsColumns = (onEdit, onDelete) => () => [
  {
    title:'Name',
    dataIndex: 'name',
  },{
    dataIndex: 'edit',
    width: 50,
    render:(_,record) => (
      <BorderlessButton iconNode={<EditOutlined/>} onClick={onEdit(record)}/>
    ),
  },{
    dataIndex: 'delete',
    width: 50,
    render:(_,record) => (
      <BorderlessButton iconNode={<DeleteOutlined style={{ color: 'red' }}/>} onClick={onDelete(record)}/>
    ),
  }
]

export const cardTitleValidator = (id, cardTitleMap) => (_, value) => {
  const lowerValue = value ? value.toLowerCase() : value;
  const {
    [lowerValue]: {
      id: existingId,
      title: existingTitle,
    } = {},
  } = cardTitleMap;
  if (existingId && existingId !== id) return Promise.reject(`Card with title ${existingTitle} already exists`);
  return Promise.resolve();
};

export const formatCardTitle = (card) => {
  const prefix = card.number ? `${card.number} - ` : '';
  const suffix = card.title || '';
  return `${prefix}${suffix}`;
};

export const validateLink = async (_rule, value) => {
  if (
    (value?.linkType && !value?.linkId)
    || (value?.linkId && !value?.linkType)
  ) return Promise.reject(new Error('Please select a valid link'));
  return Promise.resolve();
};


export const insertCardIntoCorrectPosition = ({
  card,
  boardSettings,
  cardTemplates,
  fullCards,
  destinationCards = [],
}) => {
  const newDestinationCards = [...destinationCards];

  if (!card) return newDestinationCards;

  // Need to do an optimistic sort here if the sort type is not default
  if (boardSettings?.sortType && boardSettings?.sortType !== 'default') {
    // Optimistic sort
    const [sortType, sortOrder] = boardSettings.sortType.split('-');
    const relevantCardTemplate = cardTemplates?.[boardSettings.cardTypeId];
    const titleKey = relevantCardTemplate?.useCardNumberAsCardTitle ? 'number' : 'title';
    const isStringCompare = sortType === 'title' && !relevantCardTemplate?.useCardNumberAsCardTitle;

    // binary insert
    let mod = sortOrder === 'asc' ? 1 : -1;
    const sortKey = sortType === 'title' ? titleKey : 'lastMoveTimestamp';
    // last move timestamp is the inverse
    // as the greater the number, the closer it is was to being moved
    if (sortKey === 'lastMoveTimestamp') mod *= -1;
    let low = 0;
    let high = newDestinationCards.length - 1;
    // Perform a binary search to find the index to insert the card
    while (low <= high) {
      const mid = Math.floor((low + high) / 2);
      const midCard = fullCards?.[newDestinationCards[mid]];

      if (!midCard) low = mid + 1;

      if (isStringCompare) {
        if (midCard[sortKey] && midCard[sortKey].localeCompare(card[sortKey]) * mod > 0) {
          high = mid - 1;
        } else {
          low = mid + 1;
        }
      } else if (midCard[sortKey] * mod > card[sortKey] * mod) {
        high = mid - 1;
      } else {
        low = mid + 1;
      }
    }

    // Insert the card at the found index
    newDestinationCards.splice(low, 0, card.id);
  } else {
    newDestinationCards.push(card.id);
  }

  return newDestinationCards;
}
